<template>
  <a-modal
    title="交易密码"
    v-model="modalShow"
    width="50%"
    @cancel="close"
    destroyOnClose
  >
    <div class="spaceCenter common">
      <div>
        <div class="spaceLeft item-box">
          <label>交易密码：</label>
          <a-input type="password" v-model="txnPwd" class="item-input" />
        </div>
      </div>
    </div>
    <template slot="footer">
      <a-button class="btn-blue-line" @click="close()">取消</a-button>
      <button-load @clickHandle="modalOk" :disabled="!txnPwd" type="primary" lable="确认" />
    </template>
  </a-modal>
</template>

<script>
import { verifyTradePassword } from "@/api/gold.js";
export default {
  data() {
    return {
      modalShow:false,
      txnPwd: ""
    };
  },
  methods: {
    open() {
      this.modalShow = true;
    },
    close() {
      this.modalShow = false;
    },
    modalOk(btn) {
      if (!this.txnPwd || this.txnPwd.length < 6) {
        this.$message.error('请输入有效的交易密码');
        return;
      }
      let params = { tradePassword: this.txnPwd };
      verifyTradePassword(params)
        .then((res) => {
          this.$emit("success", this.utils.getPasswordEncryptString(this.txnPwd));
          btn.closeLoad();
          this.close();
        })
        .catch((error) => {
          btn.closeLoad();
          console.log(error);
        });
    },
  }
};
</script>
<style scoped>
    .item-box > label {
        min-width: 70px;
    }
    .item-box {
        margin: 0 15px 15px 0;

    }
    .item-input {
        width: 200px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/bill-payment/common-password-modal.vue